module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAAnElEQVQ4jZXUMQpCMRCE4T8iOYK38Rb2Vnopr2DlrbSythmbPMgLSXYSCGyRDzYwu0jCvFnSWVI+4p0MPEt9PSyCG/CNUAs+gGaoCwBGaAhGaAp6KAQtskCNbLChJQCQJL1KfQfeEajbw3lco0upH8AJSA76rcKtvSVY/8mGbSIs2MteCEcpn8LZPA1hNLldmCQrCLvF4q6v3Qr7AwMohZlN90SBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jt_r.png
// module id = 1t9V
// module chunks = 15